export default "__VITE_ASSET__CbZKd0RX__"